import React from 'react';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  description?: React.ReactNode;
  centered?: boolean;
  className?: string;
  variant?: 'default' | 'light' | 'dark';
}

export default function SectionHeader({
  title,
  subtitle,
  description,
  centered = false,
  className,
  variant = 'default',
}: SectionHeaderProps) {
  const isDarkBg = variant === 'dark';

  return (
    <div className={cn(
      "mb-12",
      centered ? "text-center mx-auto max-w-3xl" : "max-w-4xl",
      className
    )}>
      {subtitle && (
        <span className={cn(
          "kicker",
          isDarkBg ? "text-primary-foreground/90" : "text-primary"
        )}>
          {subtitle}
        </span>
      )}
      <h2 className={cn(
        "text-3xl md:text-4xl font-bold mb-6 leading-tight tracking-tight",
        isDarkBg ? "text-white" : "text-foreground"
      )}>
        {title}
      </h2>
      {description && (
        <div className={cn(
          "text-sm leading-relaxed",
          isDarkBg ? "text-white/70" : "text-muted-foreground"
        )}>
          {description}
        </div>
      )}
    </div>
  );
}
